import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Row } from 'antd';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';


import PortfolioSelector from '../Portfolio/PortfolioSelectors/PortfolioSelector';
import { fetchDetailedPortfolioObjects } from "../../api/portfolioApi";
import { selectFullPortfolios } from "../../store/slices/portfolios.slice";
import PortfolioXray from "./PortfolioXray";

const XrayLauncher = () => {
    const dispatch = useDispatch();
    const [view, setView] = useState('select');
    const [portfolioIds, setPortfolioIds] = useState([]);
    const fullPortfolioObjects = useSelector(state => selectFullPortfolios(state, portfolioIds));

    // Handle portfolio selection from PortfolioSelector
    const handlePortfolioSelection = (selectedPortfolios) => {
        const selectedIds = selectedPortfolios.map(p => p.id);
        setPortfolioIds(prevIds=>[...prevIds, ...selectedIds]);
        if (selectedIds.length > 0) {
            fetchPortfolios(selectedIds);
        }
    };

    // Fetch detailed portfolio data
    const fetchPortfolios = async (ids) => {
        try {
            await dispatch(fetchDetailedPortfolioObjects(ids));
            setView('xray');
        } catch (error) {
            console.error('Error fetching portfolio details:', error);
            // You might want to add error handling UI here
        }
    };

    const reformatSymbols = (symbols)=>{
        const newObj = {};
        Object.keys(symbols).forEach((key)=>{
            newObj[key] = {wgt: symbols[key]}
        });
        return newObj;
    }

    // Render different views based on state
    const renderContent = () => {
        switch (view) {
            case 'select':
                return (
                    <Card className="w-full max-w-4xl mx-auto">
                        <PortfolioSelector
                            onSelect={handlePortfolioSelection}
                            initialSelectedPortfolios={[]}
                            allowTypes={['b', 's', 'm']}
                            maxSelected={20}
                        />
                    </Card>
                );
            case 'xray':
                return fullPortfolioObjects ? (
                    <div>
                        <Row>
                            <ButtonGroup>
                                <Button onClick={()=>setView('select')}>Add Portfolios</Button>
                            </ButtonGroup>
                        </Row>

                        <PortfolioXray
                            portfolios={[...fullPortfolioObjects.map(x=>({
                                name: x.name,
                                ptfl: reformatSymbols(x.symbols),
                                key: x.id
                            }))]}
                            onBack={() => setView('select')}
                            onRemove={(key) => {
                                setPortfolioIds(prevIds=>prevIds.filter(id=>id!==key));
                            }}
                        />
                    </div>
                ) : (
                    <div className="flex justify-center items-center h-32">
                        Loading portfolio data...
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="p-4">
            {renderContent()}
        </div>
    );
};

export default XrayLauncher;